export default __webpack_public_path__ + "static/nidhidao-f1ac4c7aee14b72a63f33f1d349ce8be.jpg";